import { Component, OnInit } from "@angular/core";
import { RouterModule } from "@angular/router";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";
import { HeaderComponent } from "../shared/header/header.component";
import { CommonModule } from "@angular/common";
import { FooterComponent } from "../shared/footer/footer.component";


@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  standalone: true,
  imports: [CommonModule, HeaderComponent, FooterComponent, RouterModule]
})
export class MainComponent {
  backgroundNil: boolean = false;

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.router.events
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        window.scrollTo(0, 0);
        const navigationEnd = event as NavigationEnd;

        this.backgroundNil = navigationEnd.url !== "/home";
      });
  }
}
